<form-page-layout [title]="title"
                  [errors]="errors"
                  [successes]="successes"
                  [goBackLink]="goBackLink"
                  [icon]="icon">
  <form ngNativeValidate (ngSubmit)="save()">
    <ng-content></ng-content>
    <form-page-button-block [goBackLink]="goBackLink" [cancelText]="cancelText" [showSave]="showSave"></form-page-button-block>
  </form>
</form-page-layout>